import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

const HelmetTitle = ({ title }: { title?: string }) => {
  const [baseTitle, setBaseTitle] = useState('Cogknit');

  useEffect(() => {
    // Get initial title from HTML, e.g., "MyApp"
    if (typeof document !== 'undefined') {
      const htmlTitle = document.querySelector('title')?.innerText;
      if (htmlTitle) setBaseTitle(htmlTitle);
    }
  }, []);

  const fullTitle = title ? `${baseTitle} | ${title} ` : baseTitle;

  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
};

export default HelmetTitle;
